import React, { Component } from "react";
import ImageCarousel from "./ImageCarousel";

const toWebp = (src) => src.replace(/\.(jpe?g|png)$/i, ".webp");

class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCarousel: false,
      initialIndex: 0
    };
  }

  openCarousel = (clickedIndex) => {
    this.setState({ showCarousel: true, initialIndex: clickedIndex });
  };

  closeCarousel = () => {
    this.setState({ showCarousel: false });
  };

  render() {
    if (!this.props.data) return null;

    const projects = this.props.data.projects.map((project, index) => {
      const projectImage = "images/portfolio/" + project.image;
      const projectImageWebp = toWebp(projectImage);

      return (
        <div key={project.image} className="columns portfolio-item">
          <div className="item-wrap" onClick={() => this.openCarousel(index)}>
            <picture>
              <source srcSet={projectImageWebp} type="image/webp" />
              <img
                alt={project.title}
                src={projectImage}
                width="800"
                height="600"
                loading="lazy"
                decoding="async"
              />
            </picture>
            <div style={{ textAlign: "center" }}>{project.title}</div>
          </div>
        </div>
      );
    });

    const carouselImages = this.props.data.projects.map(project => ({
      src: "images/portfolio/" + project.image,
      srcWebp: toWebp("images/portfolio/" + project.image),
      alt: project.title,
      title: project.title
    }));

    return (
      <section id="portfolio">
        <div className="row">
          <div className="twelve columns collapsed">
            <h2>Câteva poze din service-ul nostru</h2>
            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
              {projects}
            </div>
          </div>
        </div>

        <ImageCarousel
          isOpen={this.state.showCarousel}
          images={carouselImages}
          initialIndex={this.state.initialIndex}
          onClose={this.closeCarousel}
        />
      </section>
    );
  }
}

export default Portfolio;
